import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, Checkbox, Button, Col, Row } from 'antd';
import { GetById_Period_Api, Update_Period_Api } from '../../API/PeriodApi'; // فرض شده است
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// وارد کردن DatePicker و تنظیمات شمسی
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// =================================================================
// فرمت مورد نظر سرور برای تاریخ شمسی با خط تیره و ارقام انگلیسی
const SERVER_DATE_FORMAT = "YYYY-MM-DD"; 

/**
 * تابع کمکی برای تبدیل ارقام فارسی (و عربی) در یک رشته به ارقام انگلیسی/لاتین،
 * حذف فضاهای خالی و تبدیل اسلش به خط تیره برای سازگاری با فرمت سرور.
 * @param {string} str - رشته‌ای شامل ارقام فارسی/عربی.
 * @returns {string} - رشته‌ای با ارقام انگلیسی و فرمت YYYY-MM-DD.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    
    // 1. حذف هرگونه فضای خالی (در ابتدا و انتها)
    let output = String(str).trim(); 

    // 2. تبدیل ارقام فارسی و عربی به انگلیسی
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    // 3. تبدیل اسلش به خط تیره برای سازگاری با فرمت مورد نیاز سرور (1372-12-22)
    return output.replace(/\//g, "-"); 
};

// =================================================================
// کامپوننت آداپتور برای اتصال DatePicker به Form.Item آنت‌دیزاین
const PersianDatePickerAdapter = ({ value, onChange }) => {
    const [dateValue, setDateValue] = useState(null);

    // تبدیل مقدار رشته‌ای (با فرمت سرور) به DateObject برای نمایش در تقویم
    const toDateObject = (dateString) => {
        if (!dateString) return null;
        const englishDateString = persianToEnglishNumbers(dateString); 
        
        return new DateObject({
            calendar: persian,
            locale: persian_fa,
            date: englishDateString,
            format: SERVER_DATE_FORMAT 
        });
    };
    
    // اثر جانبی: به‌روزرسانی State داخلی DatePicker هنگام تغییر مقدار "value" (مثل زمان بارگذاری اولیه)
    useEffect(() => {
        setDateValue(toDateObject(value));
    }, [value]);

    // هندل کردن تغییرات کاربر در تقویم
    const handleOnChange = (dateObject) => {
        setDateValue(dateObject); 

        let dateString = null;
        if (dateObject) {
            // خروجی گرفتن از DateObject با فرمت مورد نیاز سرور (YYYY-MM-DD)
            const persianDateString = Array.isArray(dateObject) ? 
                         dateObject.map(d => d.format(SERVER_DATE_FORMAT)) : 
                         dateObject.format(SERVER_DATE_FORMAT);

            // تبدیل ارقام فارسی به انگلیسی در لحظه خروج برای ارسال به State خارجی
            dateString = persianToEnglishNumbers(persianDateString);
        }
        
        // ارسال مقدار رشته‌ای تمیز و انگلیسی (با خط تیره) به Form.Item
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input" 
            calendarPosition="bottom-right"
            // فرمت نمایش در کادر ورودی باید با فرمت سرور تطابق داشته باشد
            format={SERVER_DATE_FORMAT} 
        />
    );
};
// =================================================================
export const EditPeriodComponent = ({ id, setLoading, showMessage, rowUpdated, cancelEdit }) => {
    
    // =================================================================
    // تعریف تمامی State های مورد نیاز برای مدیریت فیلدهای تاریخ و ReactQuill
    const [period, setPeriod] = useState();
    
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [registerFromDate, setRegisterFromDate] = useState(null);
    const [registerToDate, setRegisterToDate] = useState(null);

    const [adminRegisterFromDate, setAdminRegisterFromDate] = useState(null);
    const [adminRegisterToDate, setAdminRegisterToDate] = useState(null);

    const [takeDocumentsFromDate, setTakeDocumentsFromDate] = useState(null);
    const [takeDocumentsToDate, setTakeDocumentsToDate] = useState(null);

    const [lotteryDate, setLotteryDate] = useState(null);

    const [comment, setComment] = useState('');
    const [additionalFileComment, setAdditionalFileComment] = useState('');
    const [form] = Form.useForm()
    // =================================================================
    
    useEffect(() => {
        loadData();
    }, [id]);

    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_Period_Api(id);
            setLoading(false);
            if (data.messageStatus === "Successful") {
                const periodData = data.messageData.data;
                setPeriod(periodData);

                // مقداردهی State ها از اطلاعات دریافتی از سرور
                setFromDate(periodData.from_Shamsi); 
                setToDate(periodData.to_Shamsi);
                setRegisterFromDate(periodData.registration_From_Shamsi);
                setRegisterToDate(periodData.registration_To_Shamsi);
                setAdminRegisterFromDate(periodData.adminRegistration_From_Shamsi);
                setAdminRegisterToDate(periodData.adminRegistration_To_Shamsi);
                setTakeDocumentsFromDate(periodData.takeDocuments_From_Shamsi);
                setTakeDocumentsToDate(periodData.takeDocuments_To_Shamsi);
                setLotteryDate(periodData.lotteryDate_Shamsi);
                
                setComment(periodData.comment);
                setAdditionalFileComment(periodData.additionalFileComment);

                form.setFieldsValue(periodData);

            }
            else {
                showMessage(data.message, "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }


    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            // ساخت شیء نهایی برای ارسال به API، با اعمال تبدیل نهایی بر روی تاریخ‌ها
            const updatedValues = {
                ...values,
                categoryTitle: "",
                // اعمال تابع persianToEnglishNumbers که اکنون Trim و فرمت YYYY-MM-DD را تضمین می‌کند
                from_Shamsi: persianToEnglishNumbers(fromDate),
                to_Shamsi: persianToEnglishNumbers(toDate),
                registration_From_Shamsi: persianToEnglishNumbers(registerFromDate),
                registration_To_Shamsi: persianToEnglishNumbers(registerToDate),
                adminRegistration_From_Shamsi: persianToEnglishNumbers(adminRegisterFromDate),
                adminRegistration_To_Shamsi: persianToEnglishNumbers(adminRegisterToDate),
                takeDocuments_From_Shamsi: persianToEnglishNumbers(takeDocumentsFromDate),
                takeDocuments_To_Shamsi: persianToEnglishNumbers(takeDocumentsToDate),
                lotteryDate_Shamsi: persianToEnglishNumbers(lotteryDate),
                comment: comment,
                additionalFileComment: additionalFileComment,
            }

            console.log("Values Sent to API:", updatedValues);

            let data = await Update_Period_Api(updatedValues);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful")
                rowUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    
    return (
        <>
            {period ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {period.title}
                        </h2>
                    </div>

                    <div className='container'>
                        <Form
                            name="basic"
                            form={form}
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 19 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item name="id" hidden={true} />
                            
                            <Form.Item name="title" label="عنوان" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <Input placeholder='عنوان' />
                            </Form.Item>
                            <Form.Item name="subTitle1" label="زیر عنوان1" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <Input placeholder='زیر عنوان1' />
                            </Form.Item>
                            <Form.Item name="subTitle2" label="زیر عنوان2" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <Input placeholder='زیر عنوان2' />
                            </Form.Item>

                            {/* فیلدهای تاریخ با استفاده از PersianDatePickerAdapter جدید و به‌روزرسانی State */}
                            <Form.Item name="from_Shamsi" label="از تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={fromDate} onChange={setFromDate} />
                            </Form.Item>

                            <Form.Item name="to_Shamsi" label="تا تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={toDate} onChange={setToDate} />
                            </Form.Item>

                            <Form.Item name="registration_From_Shamsi" label="ثبت نام از تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={registerFromDate} onChange={setRegisterFromDate} />
                            </Form.Item>

                            <Form.Item name="registration_To_Shamsi" label="ثبت نام تا تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={registerToDate} onChange={setRegisterToDate} />
                            </Form.Item>

                            <Form.Item name="adminRegistration_From_Shamsi" label="ثبت نام مدیر از تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={adminRegisterFromDate} onChange={setAdminRegisterFromDate} />
                            </Form.Item>

                            <Form.Item name="adminRegistration_To_Shamsi" label="ثبت نام مدیر تا تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={adminRegisterToDate} onChange={setAdminRegisterToDate} />
                            </Form.Item>
                            
                        

                            <Form.Item name="takeDocuments_From_Shamsi" label="تحویل مدارک از تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={takeDocumentsFromDate} onChange={setTakeDocumentsFromDate} />
                            </Form.Item>

                            <Form.Item name="takeDocuments_To_Shamsi" label="تحویل مدارک تا تاریخ" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={takeDocumentsToDate} onChange={setTakeDocumentsToDate} />
                            </Form.Item>
                            
                            {/* فیلدهای Checkbox و InputNumber */}
                            <Form.Item name="categoryId" hidden={true} />
                            <Form.Item name="isLottery" label="آیا قرعه کشی دارد؟ " valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                                <Form.Item name="lotteryDate_Shamsi" label="تاریخ قرعه کشی" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <PersianDatePickerAdapter value={lotteryDate} onChange={setLotteryDate} />
                            </Form.Item>
                            <Form.Item label="تعداد ثبت نام قرعه کشی" name="numberOfReserveForLottery">
                                <InputNumber />
                            </Form.Item>
                            <Form.Item name="isTimesFix" label="آیا تایم فیکس است؟ " valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item label="حداکثر شب مجاز" name="maxNight">
                                <InputNumber />
                            </Form.Item>
                            <Form.Item name="forceEnterOther" label="گرفتن اطلاعات همراهان؟" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="getOthersPhoto" label="گرفتن تصویر از همراهان؟" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="forceGetOthersPhoto" label="اجبار در گرفتن تصویر همراهان؟" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="canReserveForOther" label="اجازه رزرو برای دیگری؟" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            
                            {/* فیلدهای ReactQuill */}
                            <Form.Item name="comment" label="توضیحات" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <ReactQuill value={comment} onChange={setComment} placeholder="متن خود را وارد کنید..." theme="snow" />
                            </Form.Item>

                            <Form.Item name="getAdditionalFile" label="مرحله بارگذاری مدارک دارد؟" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="additionalFileMaxSize" label="ماکزیمم سایز مجاز فایل">
                                <InputNumber />
                            </Form.Item>
                            <Form.Item name="additionalFileCount" label="ماکزیمم تعداد فایل مجاز">
                                <InputNumber />
                            </Form.Item>

                            <Form.Item name="additionalFileComment" label="توضیحات مرحله بارگذاری مدارک" rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}>
                                <ReactQuill value={additionalFileComment} onChange={setAdditionalFileComment} placeholder="متن خود را وارد کنید..." theme="snow" />
                            </Form.Item>

                            {/* فیلدهای پرداخت */}
                            <Form.Item name="havePayment" label="مرحله پرداخت دارد؟" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="enablePayByFish" label="پرداخت با ثبت فیش" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="enableElectronicPay" label="پرداخت الکترونیک" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="enableFoodReserve" label="رزرو غذا دارد" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="enableParkingReserve" label="رزرو پارکینگ دارد" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="enablePayByFish_FoodAndParking" label="پرداخت غذا/پارکینگ با فیش" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            <Form.Item name="enableElectronicPay_FoodAndParking" label="پرداخت الکترونیک غذا/پارکینگ" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                            
                            <Form.Item name="isActive" label="فعال" valuePropName='checked'>
                                <Checkbox />
                            </Form.Item>
                        </Form>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}